function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React__default from 'react';
import socialLinks from '../social-media.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var socialLinksArray = Object.keys(socialLinks).map(function (key) {
  return __spreadValues({
    type: key
  }, socialLinks[key]);
});
var SocialIcons = function SocialIcons(_ref) {
  var handleClick = _ref.handleClick;
  function _onClick(type) {
    var payload = {
      elementType: "link",
      location: "footer",
      position: "Siga a gente",
      text: type
    };
    if (handleClick) {
      handleClick(payload);
    }
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__links-group"
  }, /* @__PURE__ */React__default.createElement("p", {
    className: "footer-cp__title"
  }, "Siga a gente"), /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__links-box"
  }, socialLinksArray.map(function (_ref2, index) {
    var href = _ref2.href,
      title = _ref2.title,
      svg = _ref2.svg,
      type = _ref2.type;
    return /* @__PURE__ */React__default.createElement("a", {
      className: "footer-cp__links-icon",
      key: "social-link-".concat(index),
      target: "_blank",
      rel: "noopener",
      title: title,
      href: href,
      "data-type": type,
      onClick: function onClick() {
        return _onClick(type);
      },
      dangerouslySetInnerHTML: {
        __html: svg
      }
    });
  })));
};
export { SocialIcons as default };